import React from 'react';
import styled from 'styled-components';
import { RichH2, RichH3 } from '../Typography';
import media from '../../utils/media';
import { isFieldValid } from '../../utils/validation';
const TextTitleContainer = styled.div `
  max-width: 540px;
  margin: 0;
  padding: 80px 0px 20px;
  ${media.tablet} {
    text-align: left;
    padding: 20px 0px 10px;
    margin: 0 auto;
  }
  ${media.mobile} {
    padding: 20px 15px 10px;
  }
`;
const ChartTitleContainer = styled.div `
  max-width: 540px;
  margin: 0;
  padding: 0px 0px 48.27px 0px;
  ${media.smallTablet} {
    padding: 0px 0px 36px 5px;
  }
  ${media.mobile} {
    padding: 20px 15px 10px;
  }
`;
export const TextTitle = ({ fields }) => {
    if (!fields || !isFieldValid(fields.textTitle)) {
        return null;
    }
    const { textTitle } = fields;
    return (React.createElement(TextTitleContainer, null,
        React.createElement(RichH2, { field: textTitle })));
};
export const ChartTitle = ({ fields }) => {
    if (!fields || !isFieldValid(fields.chartTitle)) {
        return null;
    }
    const { chartTitle } = fields;
    return (React.createElement(ChartTitleContainer, null,
        React.createElement(RichH3, { field: chartTitle })));
};
